"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Option = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const option_style_1 = __importDefault(require("./option.style"));
const icons_1 = require("../../icons");
class Option extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, label, value, selected, onClick } = this.props;
            const rootProps = {
                className: classes.root,
                value,
                'data-is-selected': selected,
                onClick
            };
            return (jsx_runtime_1.jsxs("button", Object.assign({}, rootProps, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.prefix }, { children: selected && jsx_runtime_1.jsx(icons_1.icons.CheckCircleFill, {}, void 0) }), void 0),
                    jsx_runtime_1.jsx("div", Object.assign({ className: classes.label }, { children: label }), void 0)] }), void 0));
        };
    }
}
exports.Option = Option;
Option.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    label: prop_types_1.default.string.isRequired,
    value: prop_types_1.default.string.isRequired,
    onClick: prop_types_1.default.func.isRequired,
    selected: prop_types_1.default.bool
};
Option.defaultProps = {
    selected: false
};
exports.default = react_jss_1.default(option_style_1.default)(Option);
//# sourceMappingURL=option.js.map